<template>
  <div id="Dingweizoushi">
    <div class="tr-header">
      <p class="title">即时开奖</p>
      <p
        class="handle"
        style="cursor:pointer"
        v-if="!showHistory"
        @click="handleShowHistory"
      >
        开奖历史
      </p>
      <div class="dayHandles" v-if="showHistory">
        <p @click="selectDay = today" :class="{ active: selectDay == today }">
          今天
        </p>
        <p
          @click="selectDay = yesterday"
          :class="{ active: selectDay == yesterday }"
        >
          昨天
        </p>
        <p
          @click="selectDay = beforeYesterday"
          :class="{ active: selectDay == beforeYesterday }"
        >
          前天
        </p>
        <DatePicker
          :value="selectDay"
          @on-change="dateChange"
          type="date"
          style="width: 200px;margin-left:10px"
        ></DatePicker>
      </div>
    </div>
    <div class="tr-table-container">
      <div class="check_box">
        <span>号码选择:</span>
        <CheckboxGroup v-model="showList" @on-change="checkAllGroupChange">
          <Checkbox
            v-for="(it, i) in ['一', '二', '三', '四', '五', '六']"
            :key="it"
            :label="i"
            >正码{{ it }}</Checkbox
          >
          <Checkbox :label="6">特码</Checkbox>
        </CheckboxGroup>
      </div>
      <div v-if="betType != 'ks'" class="check_box_one">
        <span>选择属性:</span>
        <div v-if="dataSource.length > 0">
          <span
            :class="{ checked_button: ballIndex == i }"
            class="handle"
            v-for="(it, i) in lhcSelectList"
            :key="i"
            @click="handleSelect(it, i)"
            >{{ it.name }}</span
          >
        </div>
      </div>
      <div class="check_box" v-if="typeName.length > 0">
        <span>选择条件:</span>
        <CheckboxGroup v-model="condition" @on-change="checkChange">
          <Checkbox v-for="(it, i) in typeName" :key="it" :label="it">{{
            it
          }}</Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="columns" :data="dataSource" border></Table>
      <div class="page">
        <Page :total="total" :page-size="50" @on-change="handleMoreData" />
        <!-- <Button type="primary" :loading="loading" :disabled="noMore" @click="handleMoreData">
          <span v-if="!loading">{{loadingTxt}}</span>
          <span v-else>加载中...</span>
        </Button>-->
      </div>
    </div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";
import { LHC_TYPE_NAME, LHC_TYPE_LIST } from "../../../helpers/BETTYPEDATA.js";

const today = dayjs(new Date()).format("YYYY-MM-DD");
const yesterday = dayjs(new Date())
  .add(-1, "day")
  .format("YYYY-MM-DD");
const beforeYesterday = dayjs(new Date())
  .add(-2, "day")
  .format("YYYY-MM-DD");

export default {
  name: "Dingweizoushi",
  data() {
    return {
      noMore: false,
      loadingTxt: "加载更多",
      loading: false,
      pageSize: 50,
      startRow: 0,
      total: 0,
      showHistory: false,
      today,
      yesterday,
      beforeYesterday,
      selectDay: today,
      lhcSelectList: LHC_TYPE_LIST,
      typeName: LHC_TYPE_LIST[0].list,
      showList: [],
      condition: [],
      fiveLine: [],
      sesx: [],
      sxType: "sx",
      columns: [],
      pageSize: 30,
      dataSource: [],
      checked: "3",
      ballIndex: 0
      // startDate: ""
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.modeType == "LhcHistory") {
          this.showHistory = true;
        }
        this.getDate();
      }
    },
    selectDay() {
      this.getDate();
    }
  },

  methods: {
    dateChange(date) {
      this.selectDay = date;
    },
    //更多
    async handleMoreData() {
      this.loading = true;
      this.startRow = (page - 1) * 50;
      await this.getDate("push");
      this.loading = false;
    },
    handleShowHistory() {
      window.location.href = `/Trend/lhc/${this.$route.params.gameType}?modeType=LhcHistory`;
    },
    handleSelect(it, i) {
      this.sxType = it.type;
      this.ballIndex = i;
      this.typeName = it.list;
      this.condition = [];
    },
    checkChange() {},
    checkAllGroupChange() {},
    reset(data) {
      console.log(this.betType);
      this.columns = columns(this.betType, data, this.ballIndex).list(this);
      console.log(this.columns);
    },
    async getDate(type) {
      let req = {
        gameType: this.$route.params.gameType,
        isNeed: 1,
        pageSize: this.pageSize,
        startRow: this.startRow,
        date: this.showHistory ? this.selectDay : ""
      };

      // queryKcReportByIssue
      let res = await this.$http.post("/queryKcReportByIssue.do", req);
      if (res.data.returnCode == "0000") {
        // if (res.data.returnList.length == 0) {
        //   this.loadingTxt = "到底了~";
        //   this.noMore = true;
        //   return;
        // }

        let arr = format.formatJson(res.data.returnList);
        this.fiveLine = res.data.returnMap.fiveLine.split(";");
        this.sesx = res.data.returnMap.sesx.split(";");
        this.total = res.data.totalCount;
        // if (type == "push") {
        //   this.dataSource.push(...arr);
        // } else {
        this.dataSource = arr;
        // }
        this.dataSource.map((it, i) => {
          var ball = it.balls.split(",");
          it.ballList = ball;
          this.formatsx(it);
        });
        console.log(arr);
        this.reset(arr);
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatsx(it) {
      var sx = [
        "猴",
        "鸡",
        "狗",
        "猪",
        "鼠",
        "牛",
        "虎",
        "兔",
        "龙",
        "蛇",
        "马",
        "羊"
      ];
      var wx = ["金", "木", "水", "火", "土"];
      var sxArr = [];
      var wxArr = [];
      let date = new Date();
      for (let j = 0; j < it.ballList.length; j++) {
		  //六合彩生肖
        let gap = date.getFullYear() - it.ballList[j] + 1;
        let idx = gap % 12;
        sxArr.push(sx[idx]);
      }

      for (let i = 0; i < it.ballList.length; i++) {
        for (let j = 0; j < this.fiveLine.length; j++) {
          if (this.fiveLine[j].includes(it.ballList[i])) {
            wxArr.push(wx[j]);
            break;
          }
        }
      }
      it.sx = sxArr;
      it.wx = wxArr;
    }
    // formatLost(arg) {
    //   var name = `ball${this.ballIndex + 1}`;
    //   this.divideList = arg[0].ball_json[name].nums;
    //   // console.log(this.divideList, "242342342");
    // },
    // 走势图
    // createCanvas() {
    //   let tableContent = document.querySelector(".tr-table-container");
    //   let table = document.querySelector(".ivu-table-tbody");

    //   let tablePos = table.getBoundingClientRect();
    //   let tableleft = tablePos.left;
    //   let tabletop = tablePos.top;
    //   //设置画布
    //   let cvs = document.createElement("canvas");
    //   cvs.style.marginTop = -table.offsetHeight + "px";
    //   cvs.className = "cvs_container";
    //   cvs.height = table.offsetHeight; // 表格的高度等同画布高度
    //   cvs.width = table.scrollWidth; // 表格的高度等同画布高度
    //   var redList = document.querySelectorAll(".red");
    //   let length;
    //   if (this.betType == "ks") {
    //     length = this.dataSource[0].ballList.length; // 开奖球数 5  就是列数
    //   } else {
    //     length = 1; // 只有 1 列
    //   }
    //   let redLength = redList.length; // 中奖号码球数 150
    //   let canvasArr = []; // 画笔坐标系
    //   for (let i = 0; i < length; i++) {
    //     canvasArr[i] = new Array();
    //     for (let j = 0; j < this.dataSource.length; j++) {
    //       var num = i + length * j;
    //       let dom = redList[num];
    //       let pos = dom.getBoundingClientRect();
    //       let left = pos.left + dom.offsetHeight / 2;
    //       let top = pos.top + dom.offsetWidth / 2;
    //       let a = { left: left - tableleft, top: top - tabletop - 15 };
    //       canvasArr[i].push(a);
    //     }
    //   }

    //   for (let i = 0; i < canvasArr.length; i++) {
    //     let colors = {
    //       0: "#fba75e",
    //       1: "#1fa6e8",
    //       2: "#0abe02",
    //       3: "#8485fb",
    //       4: "#46bd94",
    //       5: "#e16baa",
    //       6: "#f2b653",
    //       7: "#628ef3",
    //       8: "#5ec642",
    //       9: "#f66d6d"
    //     };
    //     let color = colors[i];
    //     let cxt = cvs.getContext("2d"); // 画笔
    //     cxt.strokeStyle = color; // 颜色
    //     cxt.beginPath();
    //     let it = canvasArr[i];
    //     if (it.length > 0) {
    //       cxt.moveTo(it[0].left, it[0].top);
    //       for (let j = 0; j < it.length; j++) {
    //         cxt.lineTo(it[j].left, it[j].top);
    //         cxt.stroke();
    //       }
    //     }
    //   }
    //   table.append(cvs); // 将绘画好的走势图接入表格dom树
    // }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/LhcJishikaijiang/index.vue